import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/community/free-board/page.tsx");
